module.exports = __webpack_public_path__ + "static/kilijan-6fa4c77d8db97c9b99613b4299ff7e7e.jpg";